import axios from '../../../axios';

const url = '/candidatesearch/api/ziplocations/';

export const getZipLocations = (query: string) => axios.get(`${url}search?query=${query}`);
